import React from "react";
import { Redirect, Route, RouteProps } from "react-router";

export interface IProtectedRouteProps extends RouteProps {
  isAuthenticated: boolean;
}

export const GuestOnlyRoute: React.FC<IProtectedRouteProps> = props => {
  if (props.isAuthenticated) {
    return <Redirect to="/" />;
  }

  return <Route {...props} />;
};
